module.exports = __webpack_public_path__ + "img/GoldenCustoms.273a4834.svg";